// Whether an analysis-list row is a tumour (somatic) run, and whether it may be offered
// the "Run AI" action.
//
// AI prioritisation ranks variants by inherited-disease phenotype match, which has no
// tumour meaning, and the backend answers 400 on /run-ai/ for a somatic analysis. The
// "Somatic" tag is what routes a row to the somatic view; the annotation fields cover
// rows whose tag is missing, and mirror the backend's has_any_somatic_signal.
//
// analysisType counts on a FASTQ row only. The legacy file-list dialog sent the Analysis
// Type last picked in the session with every request, so a germline VCF can store a stale
// 'TumorOnly' its pipeline never read.

// Both spacing variants are in the wild (libra somatic_types.SOMATIC_ANALYSIS_TYPES).
export const SOMATIC_ANALYSIS_TYPES = ['TumorOnly', 'Tumor Only', 'TumorNormal', 'Tumor Normal']

export const isSomaticAnalysisRow = (analysisRow) => {
  if (analysisRow?.tags?.includes('Somatic')) return true
  const annotation = analysisRow?.analysis_parameters?.annotation || {}
  if (analysisRow?.analysis_type === 'FASTQ' && SOMATIC_ANALYSIS_TYPES.includes(annotation.analysisType)) return true
  if (annotation.isSomatic) return true
  return typeof annotation.oncotreeCode === 'string' && annotation.oncotreeCode.trim() !== ''
}

// A finished germline analysis whose VCF pipeline completed without AI.
export const canRunAI = (analysisRow) =>
  analysisRow.status === 'DONE' &&
  (analysisRow.finished_pipelines || []).includes('VCF') &&
  !analysisRow.tags.includes('AI') &&
  !isSomaticAnalysisRow(analysisRow)
